import * as yup from 'yup';

const Schema = yup.object({
  text: yup.string().required('Text input is required'),
});

export { Schema };
